<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-11-14 14:20:04
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-09-18 10:15:34
 * @FilePath: /wemeet-admin-new/src/views/dragger/template/tpl_left_two_right_one.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="layout">
    <div class="view-height-160">
      <div class="view-height-80">
        <img
          v-if="!res.list[0].extraParams || !res.list[0].extraParams.isVideo"
          alt
          class="image-mode"
          :src="res.list[0].img"
        />
        <video v-else controls :src="res.list[0].extraParams.videoSrc" style="width: 100%; height: 100%"></video>
      </div>
      <div class="view-height-80">
        <img
          v-if="!res.list[1].extraParams || !res.list[1].extraParams.isVideo"
          alt
          class="image-mode"
          :src="res.list[1].img"
        />
        <video v-else controls :src="res.list[1].extraParams.videoSrc" style="width: 100%; height: 100%"></video>
      </div>
    </div>
    <div class="view-height-160">
      <img
        v-if="!res.list[2].extraParams || !res.list[2].extraParams.isVideo"
        alt
        class="image-mode"
        :src="res.list[2].img"
      />
      <video v-else controls :src="res.list[2].extraParams.videoSrc" style="width: 100%; height: 100%"></video>
    </div>
  </div>
</template>

<script>
  export default {
    title: '左二右一',
    props: ['res'],
  }
</script>
<style lang="scss" scoped>
  @import './tpl.scss';
  .layout {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 168px;

    background-size: cover;
  }
  .view-height-75 {
    .image-mode {
      height: 80px;
    }
  }
</style>
